import axios from '../axios/axios';
import {
  MARK_VALID_FIELDS_DATA_REQUEST,
  MARK_VALID_FIELDS_DATA_SUCCESS,
  MARK_VALID_FIELDS_DATA_FAIL,
} from '../constants/markValidFieldsConstants';

export const markValidFieldsAction = (uploadedId) => async (dispatch) => {
  try {
    dispatch({ type: MARK_VALID_FIELDS_DATA_REQUEST });
    const { data } = await axios.post('/mark-valid-keys/list', {
      upload_id: parseInt(uploadedId),
    });
    dispatch({
      type: MARK_VALID_FIELDS_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }
    dispatch({
      type: MARK_VALID_FIELDS_DATA_FAIL,
      payload: error,
    });
  }
};
